import React from "react"

export default function ColorPreviewCell(props) {
  return (
    <div className={`colorPreviewCell ${ props.colorVariable }`}>
      <div className="hStack">
        <div className="vStack">
          <div className="colorPreviewCellName">{props.colorName}</div>
          <div className="colorPreviewCellVariable">{props.colorVariable}</div>
        </div>

        <div className="colorPreviewCellValue">{props.colorValue}</div>
      </div>

      <div className="separator" />

      <div className="colorPreviewCellDescription">{props.colorDescription}</div>
    </div>
  )
}